import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface NotifyRearrangeDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isNotifying?: boolean;
  hasUserPhone?: boolean;
}

const NotifyRearrangeDialog = ({ open, onClose, onConfirm, isNotifying = false, hasUserPhone = true }: NotifyRearrangeDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('reservationsPage.confirmContactTitle', 'Confirm to contact user')}</DialogTitle>
      <DialogContent>
        <Typography>
          {hasUserPhone
            ? t('reservationsPage.confirmContactMessage', 'By confirming, we will notify user in whatsapp and email.')
            : t('reservationsPage.confirmContactMessageEmailOnly', 'By confirming, we will notify user via email only.')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={isNotifying}>
          {t('actions.cancel', 'Cancel')}
        </Button>
        <Button onClick={onConfirm} color="primary" disabled={isNotifying}>
          {isNotifying ? <CircularProgress size={24} /> : t('actions.confirm', 'Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotifyRearrangeDialog;
